// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"4c968f73","470":"f89c3f83","529":"4914650a","605":"236b9686","851":"a8cca0fe","892":"723af9fa"}[chunkId] + ".chunk.css";
};